export enum  TypeEventOperationHistory { 
    ACORDOEPLANOSDEPAGAMENTO = "CLICK_MOTIVE_LEVEL2_AGREEMENT",
    QUEROPEDIRUMACORDODEPAGAMENTO = "CLICK_MOTIVE_LEVEL3_AGREEMENT",
    INSERTNIF = "INSERT_NIF",
    VALIDATETOKEN = "VALIDATE_TOKEN",
    RESPONSEREQUESTNIF = "RESPONSE_REQUEST_NIF",
    SELECTCONTRACT = "SELECT_CONTRACT",
    REQUESTAGREEMENT = "REQUEST_AGREEMENT",
    RESPONSEREQUESTAGREEMENT = "RESPONSE_REQUEST_AGREEMENT",
    CLICKCLOSESTEP2 = "CLICK_CLOSE_STEP2",
    CLICKORDERCREATEDSTATUSANALYSIS = "CLICK_ORDER_CREATED_STATUS_ANALYSIS",
    CLICKORDERCREATEDSTATUSPENDING = "CLICK_ORDER_CREATED_STATUS_PENDING",
    CLICKORDERCREATEDSTATUSCOMPLETED = "CLICK_ORDER_CREATED_STATUS_COMPLETED",
    CLICKSTEP3ACCEPTAGREEMENT = "CLICK_STEP3_ACCEPT_AGREEMENT",
    CLICKSTEP3REJECTAGREEMENT = "CLICK_STEP3_REJECT_AGREEMENT",
    NEWREQUESTAGREEMENTEXPIRED = "NEW_REQUEST_AGREEMENT_EXPIRED",
    VIEWSTEP4CONFIRMATION = "VIEW_STEP4_CONFIRMATION",
    CLICKCLOSESTEP4CONFIRMATION = "CLICK_CLOSE_STEP4_CONFIRMATION",
    VIEWEXISTINGAGREEMENT = "VIEW_EXISTING_AGREEMENT",
    CLICKSEEEXISTINGAGREEMENT = "CLICK_SEE_EXISTING_AGREEMENT"
}